import { useQuery } from 'wasp/client/operations';
import { getBulkUploadEnabled } from 'wasp/client/operations';

/**
 * Hook to check if bulk upload functionality is enabled globally.
 * Returns true by default if the setting doesn't exist.
 */
export function useBulkUploadEnabled() {
  const { data: isEnabled = true, isLoading } = useQuery(getBulkUploadEnabled);

  return {
    isEnabled,
    isLoading
  };
}



